module.exports = __webpack_public_path__ + "static/media/ghost.3fd4b9a3.mp3";